import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { imgUrl } from '../../../common/utilities/ImgUrl';

const { Colors } = TabStyles;

export const BreakPoints = {
  'SMALL': 475,
  'MEDIUM': 768,
  'LARGE': 1024,
};

export const contentVerticalSpace = '8px';

export const metadataSectionStyle: string = style({
    padding: '8px 4px'
});

export const metadataSubTitle: React.CSSProperties = {
  fontWeight: 'bold',
  fontSize: '14px',
  color: Colors!.L9,
  marginBottom: contentVerticalSpace,
  outline: 'none',
};

export const metadataText: React.CSSProperties = {
  fontWeight: 'normal',
  fontSize: '12px',
  color: Colors!.L9,
  wordWrap: 'break-word',
};

export const metadataConnectedViewItem: React.CSSProperties = {
  marginBottom: contentVerticalSpace,
  outline: 'none',
};

export const resolveButtonContainer: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  flexFlow: 'row wrap',
};

export const resolveButton: React.CSSProperties = {
  marginLeft: 12,
};

export const editButtonClass = style({
  marginLeft: 4,
  minWidth: CommonStyles.Sizes.SmallIconSize,
  height: CommonStyles.Sizes.SmallIconSize,
  verticalAlign: 'middle',
  backgroundColor: 'transparent',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  display: 'inline-block',
  border: 'none',
  $nest: {
    '&:hover, &:focus': {
      backgroundColor: CommonStyles.Colors.Grey245,
      backgroundImage: imgUrl('menu_edit.svg')
    }
  }
});

export const editBlockStyleClass = style({
  $nest: {
    '&:hover': {
      backgroundColor: CommonStyles.Colors.Grey245,
    },
    [`&:hover .${editButtonClass}`]: {
      backgroundImage: imgUrl('menu_edit.svg'),
    }
  }
});
